<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Stock de Bins 800L por Proveedor</v-card-title>
      <v-card-text>
        <v-row class="mx-1">
          <v-col cols="4">
            <v-btn @click="download" color="primary">Excel</v-btn>
          </v-col>
        </v-row>
        <v-data-table 
          :headers="stockProvider800ListHeaders"
          :items="stockProvider800ListBody"
          class="elevation-1"
          no-data-text="No hay datos"
          :hide-default-footer="true"
          disable-pagination
          fixed-header
          :height="table_height"
        >
          <template slot="body.append">
            <tr class="primary--text">
              <th class="title text-center">Totales</th>
              <th class="title text-center" v-for="p in cols" :key="p">
                  {{ sumaColumna('val'+p) }}
              </th>
              <th class="title text-center">
                  {{ sumaColumna('total') }}
              </th>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      cols: 0,
      url_excel: '',
      isLoading: false,
      stockProvider800ListHeaders: [
        {
          text: "Dependencia", 
          width: "200px", 
          class: "salmon black--text elevation-3",
          value: 'val0',
          fixed: true
        },
      ],
      stockProvider800ListBody: [],
      table_height: 600,
    }),
    mounted() {
      this.loadProviderStockReport();
      if(window.innerHeight < 768){
        this.table_height = 450;
      }
    },
    methods:{
      sumaColumna(key) {
        let total = 0;
        this.stockProvider800ListBody.forEach(row => {
            total += parseInt(row[key]);
        });
        return total;
      },
      async loadProviderStockReport(){
        this.mostrarLoading('Generando informe, por favor espere...');
        let url2 = `${this.base_url}bins/report/provider/0/2`;
        await this.axios.get(url2, this.headers).then((response)=>{
          response.data.data.headers.forEach(h => {
            this.stockProvider800ListHeaders.push(h);
          })
          this.stockProvider800ListBody = response.data.data.body;
          this.cols = response.data.data.cols;
          this.url_excel = this.storage_url + response.data.data.url_excel;
          this.ocultarLoading();
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading();
        });
      },
      download(){
        window.location.href = this.url_excel;
      },
      ...mapMutations(['actualizarBaseUrl', 'actualizarUrlStorage', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers']),
    },
    components:{
      
    }
  }
</script>